import React, { useEffect, useMemo, useRef, useState } from "react";

export default function FloatingBubbles() {
  const [mouse, setMouse] = useState({ x: -9999, y: -9999 });
  const ticking = useRef(false);

  const bubbles = useMemo(() => {
    return Array.from({ length: 45 }, (_, i) => {
      const type = Math.random();

      let size;
      if (type < 0.65) size = Math.random() * 18 + 14;
      else if (type < 0.9) size = Math.random() * 38 + 34;
      else size = Math.random() * 70 + 80;

      return {
        id: i,
        size,
        left: Math.random() * 100,
        top: Math.random() * 100,
        drift: Math.random() * 80 - 40,
        duration: Math.random() * 28 + 22,
        delay: Math.random() * -35,
        opacity: Math.random() * 0.22 + 0.12,
      };
    });
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          setMouse({ x: e.clientX, y: e.clientY });
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="bubble-layer">
      {bubbles.map((bubble) => (
        <Bubble key={bubble.id} bubble={bubble} mouse={mouse} />
      ))}
    </div>
  );
}

function Bubble({ bubble, mouse }) {
  const ref = useRef(null);
  const [repel, setRepel] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const bubbleX = rect.left + rect.width / 2;
    const bubbleY = rect.top + rect.height / 2;

    const dx = bubbleX - mouse.x;
    const dy = bubbleY - mouse.y;
    const distance = Math.sqrt(dx * dx + dy * dy);

    const range = 190;
    const force = distance < range ? (range - distance) / range : 0;

    setRepel({
      x: dx * force * 0.9,
      y: dy * force * 0.9,
    });
  }, [mouse]);

  return (
    <span
      ref={ref}
      className="bubble-orbit"
      style={{
        left: `${bubble.left}%`,
        top: `${bubble.top}%`,
        "--drift": `${bubble.drift}px`,
        animationDuration: `${bubble.duration}s`,
        animationDelay: `${bubble.delay}s`,
      }}
    >
      <span
        className="real-bubble"
        style={{
          width: `${bubble.size}px`,
          height: `${bubble.size}px`,
          opacity: bubble.opacity,
          transform: `translate3d(${repel.x}px, ${repel.y}px, 0)`,
        }}
      />
    </span>
  );
}
